module.exports = __webpack_public_path__ + "lemon_vue/img/home_bg.53fc978.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/home_bg.png
// module id = /pxG
// module chunks = 1